import * as React from "react";

import * as moment from "moment";

import { Grid2 as Grid } from "@mui/material";

import { AdminUserStatistics, getLastUpdatedToDisplay } from "../models";
import { ADMIN_ROLES, Authorize } from "../../auth";

import { StatisticBadge } from "./StatisticBadge";

import { Link } from "redux-little-router";

interface Props {
    statistics: AdminUserStatistics;
    userId?: string;
}

export const AdminUserStatisticsGridNew = (props: Props) => {
    const today = moment.utc().format(moment.HTML5_FMT.DATE);

    return (
        <Grid container textAlign="center" rowSpacing={3} columnSpacing={{ xs: 1, md: 2, lg: 3 }} paddingBottom={1}>
            <Grid size={12}>
                <h2 className="top-statistics-padding">My Status</h2>
            </Grid>
            <Grid size="grow">
                <Link href={`/actionableTasks?userId=${props.userId}&dueDate=${today}`}>
                    <StatisticBadge label="Tasks to Complete" value={props.statistics?.tasksToCompleteCount} />
                </Link>
            </Grid>
            <Authorize roles={[ADMIN_ROLES.CLINICIAN]}>
                <Grid size="grow">
                    <Link href={`/calendar/${today}`}>
                        <StatisticBadge label="Appointments today" value={props.statistics?.appointmentsTodayCount} />
                    </Link>
                </Grid>
            </Authorize>
            <Grid size="grow">
                <StatisticBadge label="Incomplete Appointments" value={props.statistics?.incompleteAppointmentsCount} />
            </Grid>
            <Grid size="grow">
                <Link
                    // eslint-disable-next-line max-len
                    href={`/actionableTasks?userId=${props.userId}&taskTypes=WriteReportReferralTask&taskTypes=WritePhysiotherapyReportTask&taskTypes=AmendReportTask&taskTypes=AmendPhysiotherapyReportTask`}
                >
                    <StatisticBadge label="Reports to Write" value={props.statistics?.reportsToWriteCount} />
                </Link>
            </Grid>
            <Grid size="grow">
                <Link
                    href={`/actionableTasks?userId=${props.userId}&taskTypes=CaseConversationTask`}
                >
                    <StatisticBadge label="Case Conversations" value={props.statistics?.caseConversationCount} />
                </Link>
            </Grid>
            <Grid size={12} textAlign="right">
                Last Updated: {getLastUpdatedToDisplay(props.statistics?.lastUpdated)}
            </Grid>
        </Grid>
    );
};
